import { render } from "./MainCartSheet.vue?vue&type=template&id=867f8af8&scoped=true"
import script from "./MainCartSheet.vue?vue&type=script&lang=js"
export * from "./MainCartSheet.vue?vue&type=script&lang=js"

import "./MainCartSheet.vue?vue&type=style&index=0&id=867f8af8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-867f8af8"]])

export default __exports__